import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ServerError = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(20);

  useEffect(() => {
    // Countdown timer (20 seconds for 500 errors)
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-600 via-orange-600 to-yellow-500">
      <div className="text-center px-4">
        {/* Error Icon */}
        <div className="mb-8">
          <div className="w-64 h-64 mx-auto relative">
            {/* Animated Error Icon */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-pulse">
                <svg 
                  className="w-64 h-64 text-white/20" 
                  fill="currentColor" 
                  viewBox="0 0 20 20"
                >
                  <path 
                    fillRule="evenodd" 
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" 
                    clipRule="evenodd" 
                  />
                </svg>
              </div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <h1 className="text-9xl font-bold text-white drop-shadow-2xl">
                500
              </h1>
            </div>
          </div>
        </div>

        {/* Error Message */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 max-w-md mx-auto border border-white/20 shadow-2xl">
          <h2 className="text-3xl font-bold text-white mb-4">
            Server Error
          </h2>
          <p className="text-white/90 text-lg mb-6">
            Something went wrong on our end. Our team has been notified and is working on it.
          </p>

          {/* BizHub Branding */}
          <div className="mb-6">
            <p className="text-white/80 text-sm">
              <span className="font-bold text-yellow-300">BizHub</span> - Let's Talk Strategy
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <button
              onClick={handleRefresh}
              className="w-full bg-white hover:bg-gray-100 text-gray-900 font-bold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              Try Again
            </button>
            
            <button
              onClick={handleGoHome}
              className="w-full bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              Go to Dashboard
            </button>

            {/* Auto-redirect countdown */}
            <p className="text-white/70 text-sm">
              Auto-redirecting in {countdown} seconds...
            </p>
          </div>
        </div>

        {/* Support Link */}
        <div className="mt-8 text-white/80 text-sm">
          <p>
            Need help?{' '}
            <a 
              href="mailto:support@letstalkstrategy.io" 
              className="text-yellow-300 hover:text-yellow-400 underline"
            >
              Contact Support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServerError;
